import { baseApi } from '../base';
import { transformAccountLimitsResponse, AccountLimits } from './transformers';

const userApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    confirmEmail: build.mutation<void, string>({
      query: (token) => ({
        method: 'POST',
        url: `/users/email/confirm/${token}`,
      }),
    }),
    getAccountLimits: build.query<AccountLimits, void>({
      query: () => ({
        method: 'GET',
        url: '/users/limits',
      }),
      transformResponse: transformAccountLimitsResponse,
      keepUnusedDataFor: 0,
    }),
  }),
});

export const { useGetAccountLimitsQuery, useConfirmEmailMutation } = userApi;
export default userApi;
